import React from 'react';
import { Box, Modal, IconButton, Typography, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { isMobile } from 'react-device-detect';
import icon from '/images/animated-icon.gif';
import { t } from '../../i18n';

interface AboutModalProps {
    open: boolean;
    handleClose: () => void;
}

class AboutModal extends React.Component<AboutModalProps> {
    render() {
        const { open, handleClose } = this.props;

        return (
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="about-modal-title"
                aria-describedby="about-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'clamp(0px, 90vw, 300px)',
                    bgcolor: '#1E1F25',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    borderRadius: '8px',
                    boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.5)',
                    p: isMobile ? 3 : 4,
                    color: 'white',
                    boxSizing: 'border-box',
                }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'rgba(255, 255, 255, 0.7)',
                            '&:hover': {
                                color: 'white',
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Stack
                        direction="column"
                        alignItems="center"
                        spacing={1}
                        sx={{ width: '100%' }}
                    >
                        <img 
                            src={icon} 
                            alt="PokerSolutions Icon" 
                            height={60}
                            style={{ backgroundColor: '#22242C', borderRadius: '50%', padding: '.5rem' }}
                        />
                        
                        <Typography
                            id="about-modal-title"
                            variant="h5"
                            component="h2"
                            sx={{
                                fontWeight: 700,
                                fontFamily: 'Inter, serif',
                                textAlign: 'center',
                                color: 'white'
                            }}
                        >
                            {t('AboutModal:appName')}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontFamily: 'Inter, serif',
                                textAlign: 'center',
                                fontSize: isMobile ? '13px' : '14px'
                            }}
                        >
                            {t('AboutModal:version', { version: import.meta.env.VITE_APP_VERSION })}
                        </Typography>
                        
                    </Stack>
                </Box>
            </Modal>
        );
    }
}

export default AboutModal;

